import React from 'react';
import InputRange from '../../shared/InputRange';

export const SingleLineupFilters = ({ totalTime, totalPoints }) => {
  return (
    <div className="s-lineup-explorer__filter filter">
      <div className="form-row">
        <div className="form-column--xs">
          <div className="form-group">
            <label>Total Time Played</label>
            <div className="form-input-range">
              {totalTime.range && <InputRange {...totalTime} />}
            </div>
          </div>
        </div>
        <div className="form-column--xs">
          <div className="form-group">
            <label>Total Plus-Minus Points</label>
            {totalPoints.range && <InputRange {...totalPoints} />}
          </div>
        </div>
      </div>
    </div>
  );
};
